// Vendor imports
const { connect } = require('react-redux')
// Client V2 common imports
const withImmutableToJS = require('client-v2/common/components/immutable-to-js')
const withIsVisible = require('client-v2/common/components/is-visible')
const routerActions = require('client-v2/common/state/router/actions')
// Sibling imports
const shareModalActions = require('../actions')
const shareModalSelectors = require('../selectors')
const ShareModalShareFriends = require('./share-friends-dumb')

function mapStateToProps() {
  const isSocialAuthCardVisibleSelector = shareModalSelectors.createIsSocialAuthCardVisibleSelector()
  const isVisibleSelector = shareModalSelectors.createIsFriendsVisibleSelector()
  const friendsSearchSelector = shareModalSelectors.createFriendsSearchSelector()
  return function (state) {
    if (!isVisibleSelector(state)) {
      return { isVisible: false }
    }
    const { shareModal } = state
    return {
      friends: friendsSearchSelector(state),
      friendsState: shareModal.friendsState,
      isSocialAuthCardVisible: isSocialAuthCardVisibleSelector(state),
      isVisible: true,
      searchText: shareModal.searchText,
      submitState: shareModal.submitState,
      user: state.user
    }
  }
}

const mapDispatchToProps = {
  onFriendClick: shareModalActions.toggleFriend,
  onFriendsSearch: shareModalActions.setSearchText,
  onFriendsShare: shareModalActions.shareWithFriends,
  onNavigate: routerActions.navigate
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withIsVisible(
    withImmutableToJS(
      ShareModalShareFriends
    )
  )
)
